/**
 * AppSpinner — zentraler Loader-Component fuer die gesamte App.
 * -----------------------------------------------------------------------------
 * Wrappt aktuell einen BeatLoader in Freenet-Gruen (Facelift-Brand-Farbe).
 * Der Helper existiert damit spaetere Aenderungen (Spinner-Typ, Farbe, Groesse)
 * an EINER Stelle passieren und nicht in 13 JSX-Stellen ueber 10 Dateien.
 *
 * Verwendung:
 *   import AppSpinner from './AppSpinner';
 *   <AppSpinner />                  // Default: size 8, brand-Farbe
 *   <AppSpinner size={12} />        // groesser
 *   <AppSpinner color="#eaeaea" />  // andere Farbe (z.B. auf farbigem BG)
 */
import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

const AppSpinner = ({ size = 8, color = "#84bc34", ...rest }) => (
  <BeatLoader color={color} size={size} {...rest} />
);

export default AppSpinner;
